module.exports = __webpack_public_path__ + "static/media/bulb.f77e5090.png";